/**
 * imageUrl — Shopify CDN görsel yardımcıları.
 *
 * thumb(url, width): Sadece cdn.shopify.com URL'lerine güvenli şekilde
 * `width` parametresi ekler (mobilde payload'ı küçültür). Diğer host'lar
 * ve geçersiz URL'ler değiştirilmeden döner.
 *
 * hideBrokenImage(e): <img onError> — kırık görsel ikonunu gizler.
 */
const SHOPIFY_CDN_HOST = 'cdn.shopify.com';

export function isShopifyCdn(url) {
  if (typeof url !== 'string' || !url) return false;
  try {
    return new URL(url).hostname === SHOPIFY_CDN_HOST;
  } catch {
    return false;
  }
}

export function thumb(url, width = 200) {
  if (!isShopifyCdn(url)) return url || '';
  const w = Math.max(1, Math.round(Number(width) || 200));
  try {
    const u = new URL(url);
    u.searchParams.set('width', String(w));
    return u.toString();
  } catch {
    return url;
  }
}

export function hideBrokenImage(e) {
  const img = e?.currentTarget;
  if (!img) return;
  img.onerror = null;
  img.style.visibility = 'hidden';
}

/** Ortak <img> attribute seti — mobil güvenilirlik (referrer, decode, error). */
export const IMG_PROPS = {
  decoding: 'async',
  referrerPolicy: 'no-referrer',
  onError: hideBrokenImage,
};
